import './style.scss';

document.addEventListener('DOMContentLoaded', () => {
    const mainClass = 'gen-card-packages';
    const initializedClass = 'initialized';

    const packages = document.querySelectorAll(`.${mainClass}:not(.${initializedClass})`);

    packages.forEach((element) => {
        const isStyleDefault = element.classList.contains('is-style-default');
        const isStylePrimary = element.classList.contains('is-style-primary');
        const isStyleSecondary = element.classList.contains('is-style-secondary');

        if (isStyleDefault) {
            element.classList.add('gen-package-version-default');
        } else if (isStylePrimary) {
            element.classList.add('gen-package-version-primary');
        } else if (isStyleSecondary) {
            element.classList.add('gen-package-version-secondary');
        }

        element.classList.add(initializedClass);
    })
});
